import { AppServices } from '@singularsystems/neo-core';
import { NeoReactTypes } from './Types';
import { ReactModelCreator } from '../React/ReactModelCreator';
import { ErrorHandler } from '../ReactComponents/ErrorHandler';
import '../React/DataView';
import { PageLeaveHandler } from '../Routing/PageLeaveHandler';
import NavigationHelper from '../Routing/NavigationHelper';
import { runReactSetup } from './ReactSetup';
import { AutoRunnerFactory } from '../React/AutoRunner';
import { RoutingState } from '../Routing/RoutingState';
import { ContextMenuState } from '../ReactComponents/ContextMenu/ContextMenuState';
import { DisposeHelper } from '../Services/DisposeHelper';
import { IconFactory } from '../ReactComponents/Icons/IconFactory';
var neoReactModule = new AppServices.Module("neo-react", function (container) {
    container.bind(AppServices.NeoTypes.Core.AutoRunnerFactory).to(AutoRunnerFactory).inSingletonScope();
    container.bind(AppServices.NeoTypes.Core.ModelCreator).to(ReactModelCreator).inTransientScope();
    container.bind(AppServices.NeoTypes.UI.ErrorHandler).to(ErrorHandler).inSingletonScope();
    container.bind(AppServices.NeoTypes.UI.GlobalContextMenuState).toConstantValue(new ContextMenuState());
    container.bind(AppServices.NeoTypes.Routing.PageLeaveHandler).to(PageLeaveHandler).inSingletonScope();
    container.bind(NeoReactTypes.Components.IconFactory).to(IconFactory).inSingletonScope();
    container.bind(NeoReactTypes.Routing.GlobalRoutingState).to(RoutingState).inSingletonScope();
    container.bind(NeoReactTypes.Routing.NavigationHelper).to(NavigationHelper).inSingletonScope();
    container.bind(NeoReactTypes.Services.DisposeHelper).to(DisposeHelper).inTransientScope();
    runReactSetup(container);
});
export default neoReactModule;
